import type { CMSCardComponentDTO } from "~/features/cms/types/dto";
import { Card, styled } from "~/common/mui";
import { useCMSComponentRenderer } from "~/features/cms/CMSComponentRendererContext";

export type CMSCardComponentProps = Omit<CMSCardComponentDTO, "type"> & {
  className?: string;
};

export const CMSCardComponent = styled(
  ({ children, className, elevation = 0 }: CMSCardComponentProps) => {
    const renderCMSComponent = useCMSComponentRenderer();
    return (
      <StyledCard className={className} elevation={elevation}>
        {children.map((item, index) => renderCMSComponent(item, undefined, index))}
      </StyledCard>
    );
  },
  { shouldForwardProp: (prop) => prop !== "rootStyle" },
)<CMSCardComponentProps>(({ rootStyle }) => rootStyle);

const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));
